var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html, } from 'lit';
import { property } from 'lit/decorators.js';
import { JsonConfigurationSource } from './Configuration.js';
import { configurationCss } from './styles.js';
export class QboConfigEditor extends LitElement {
    constructor() {
        super(...arguments);
        this.apiEndpoint = new URL('configuration/repository', this.baseURI);
        this.buttonClass = 'buttons';
        this.configData = {};
        this.formClass = 'qbo-config-editor';
        this.rowClass = 'qbo-row';
        this.searchClass = 'search';
        this.theme = 'light';
    }
    static { this.styles = [
        configurationCss
    ]; }
    async updateConfigData(key, newValue, event, isKey = false) {
        event.preventDefault();
        if (isKey) {
            const oldValue = this.configData[key];
            delete this.configData[key];
            this.configData[newValue] = oldValue;
        }
        else {
            this.configData[key] = newValue;
        }
        this.requestUpdate();
    }
    addKeyValuePair(event) {
        event.preventDefault();
        const newKey = `newKey${Object.keys(this.configData).length}`;
        this.configData[newKey] = 'newValue';
        this.requestUpdate();
    }
    async deleteKeyValuePair(key, event) {
        event.preventDefault();
        this.clearNotifications();
        try {
            await fetch(`${this.apiEndpoint}/delete/${key}`, {
                method: 'GET'
            });
        }
        catch (err) {
            this.alertError(err);
        }
        await this.search();
        this.alertUpdated();
    }
    async saveChanges(event) {
        event.preventDefault();
        this.clearNotifications();
        try {
            await fetch(`${this.apiEndpoint}/save`, {
                method: 'POST',
                body: JSON.stringify(this.configData)
            });
        }
        catch (err) {
            this.alertError(err);
        }
        await this.search();
        this.alertUpdated();
    }
    clearNotifications() {
        this.renderRoot.querySelector(`div.error`)?.classList.add("hidden");
        this.renderRoot.querySelector(`div.success`)?.classList.add("hidden");
    }
    alertError(error) {
        dispatchEvent(new CustomEvent('qbo-error', { detail: error }));
        var alert = this.renderRoot.querySelector(`div.error`);
        if (alert) {
            alert.classList.remove("hidden");
        }
        else {
            alert = document.createElement("div");
            alert.className = "error";
            alert.innerHTML = error;
            var form = this.renderRoot.querySelector(`form`);
            form?.insertBefore(alert, form?.querySelector(`div.${this.buttonClass}`));
        }
    }
    alertUpdated() {
        var alert = this.renderRoot.querySelector(`div.success`);
        if (alert) {
            alert.classList.remove("hidden");
        }
        else {
            alert = document.createElement("div");
            alert.className = "success";
            alert.innerHTML = "Settings have been updated.";
            var form = this.renderRoot.querySelector(`form`);
            form?.insertBefore(alert, form?.querySelector(`div.${this.buttonClass}`));
        }
        setTimeout(this.alertClear, 5000, alert);
    }
    alertClear(alert) {
        alert?.classList.add("hidden");
    }
    async cancelChanges(event) {
        event.preventDefault();
        await this.search();
    }
    async filter(event) {
        if (!(event instanceof PointerEvent) && event.key !== 'Enter')
            return;
        await this.search();
    }
    async search() {
        this.clearNotifications();
        var input = this.renderRoot.querySelector(`div.${this.searchClass}`)?.querySelector('input');
        if (input instanceof HTMLInputElement) {
            if (input.value.trim() == '') {
                this.configData = {};
            }
            else {
                try {
                    const response = await fetch(`${this.apiEndpoint}/search/${input.value}`, {
                        method: "GET",
                        headers: { "Accept": "application/json" }
                    });
                    this.configData = await response.json();
                }
                catch (err) {
                    this.alertError(err);
                }
            }
        }
    }
    handleSubmit(event) {
        event.preventDefault();
    }
    render() {
        const source = new JsonConfigurationSource(this.configData);
        const header = Array.from(source.getValues()).length == 0 ? html `` : html `
    <div class="${this.rowClass}">
        <div>
          <strong>Name</strong>
        </div>
        <div>
          <strong>Value</strong>
        </div>
    </div>`;
        return html `
<form @submit="${this.handleSubmit}" class="${this.formClass}" data-bs-theme="${this.theme}">
    <div class="${this.searchClass}">
        <input type="text" @keydown="${this.filter}">
        <button type="button" @click="${this.filter}">Search</button>
    </div>
    ${header}
    ${Array.from(source.getValues()).map(({ key, value }) => html `
    <div class="${this.rowClass}">
        <div>
            <input type="text" .value="${key}" @input="${(e) => this.updateConfigData(key, e.target.value, e, true)}">
        </div>
        <div>
            <div>
                <input type="text" .value="${value}" @input="${(e) => this.updateConfigData(key, e.target.value, e)}">
                <button type="button" class="delete" @click="${(e) => this.deleteKeyValuePair(key, e)}">Delete</button>
            </div>
        </div>
    </div>`)}
    <div class="${this.buttonClass}">
        <button type="button" class="add" @click="${this.addKeyValuePair}">Add Setting</button>
        <div>
            <button type="button" class="save" @click="${this.saveChanges}">Save</button>
            <button type="button" class="cancel" @click="${this.cancelChanges}">Cancel</button>
        </div>
    </div>
</form>`;
    }
}
__decorate([
    property({ type: URL }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "apiEndpoint", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "buttonClass", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "configData", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "formClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "rowClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "searchClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboConfigEditor.prototype, "theme", void 0);
customElements.define('qbo-config-editor', QboConfigEditor);
//# sourceMappingURL=qbo-config-editor.js.map